var map = {
	"./banner_icon_1.jpg": "6fed",
	"./banner_icon_2.jpg": "6574",
	"./banner_icon_3.jpg": "40e1",
	"./banner_icon_4.jpg": "bf36",
	"./banner_icon_5.jpg": "ed86"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eae1";